import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Dropdown from 'components/Dropdown';

import UsersPropTypes from 'utils/propTypes/users';

import styles from './styles.module.scss';

const dropdownOptions = [
	{
		text: 'Профиль',
		link: '/profile'
	},
	{
		text: 'Выйти',
		link: '/auth/logout'
	}
];

const AuthButton = ({ currentUser, tabIndex }) => {
	const login = useCallback(() => {
		window.location.href = '/authorization/login?returnTo=/live';
	}, []);

	return currentUser ? (
		<Dropdown
			options={dropdownOptions}
			tabIndex={tabIndex}
			buttonElement={
				<Button
					title={currentUser.fullName}
					icon="auth"
					theme="outline"
					onClick={login}
					className={styles.ProfileMenuButton}
					tabIndex={tabIndex}
					ariaLabel={currentUser.fullName}
				/>
			}
		/>
	) : (
		<Button
			title="Войти"
			ariaLabel="Войти"
			onClick={login}
			tabIndex={tabIndex}
			className={styles.LoginButton}
		/>
	);
};

AuthButton.propTypes = {
	currentUser: UsersPropTypes.user,
	tabIndex: PropTypes.number
};

AuthButton.defaultProps = {
	currentUser: null
};

export default AuthButton;
